import React from 'react';
import {FaPrint, FaIdCard} from 'react-icons/fa';
import {RCard} from '@putil-view/item.r-card';
import {RIconText} from '@putil-view/item.r-icon-text';
import {RScanInput} from "main/item/RScanInput";
import PropTypes from 'prop-types';
import Jumbotron from 'react-bootstrap/Jumbotron';
export const QrCardReader = ({handleChangeID, message}) =>{

  return (
    <RCard className="ml-6 mr-6 mt-6 pt-4 align-self-start w-100"
      title = {
        <RIconText variant="lg">
          <FaPrint/>
          <span>Print QR Code</span>
        </RIconText>
      }>
      <Jumbotron fluid className="bg-white">
        <div className="container">
          <h4 className="text-center ">Please put your student card on the card reader to print QR code</h4>
          <br/>
          <RScanInput
            name="ID"
            label={<><FaIdCard/></>}
            info={message}
            handleChange ={handleChangeID}
          />
          <small className="text-center d-block">For SAO staff only*, If label is not printed sucessfully. Please make sure TSC TE300 is selected as default printer in your computer{"'"}s control panel.</small>
					<small className="text-center d-block">For SAO staff only*, If label is not printed automatically. Please add <span className="text-primary"> --kiosk-printing{'"'}</span> in the target field in chrome shortcut properties (content click it in desktop and select property). Then close all opened chrome browser and restart again.</small>
        <br/>
        </div>
      </Jumbotron>


    </RCard>
  )
}
QrCardReader.propTypes = {
  message:PropTypes.string,
	handleChangeID:PropTypes.func,
};
